<template>
  <div class="button">
    <a class="btn" v-on:click="update">{{ text }}</a>
  </div>
</template>

<script>
export default {
  name: 'Button',
  props: {
    text: String,
    type: String
  },
  methods: {
    update: function(){
      if(this.type == 'start'){
        this.$emit('gamestate', 'run')
      }
      else if (this.type == 'explain') {
        this.$emit('open', 'explain');
      }
    }
  }
}
</script>
